import { Vue } from 'vue-property-decorator';

import { IGoogleResponse, IVerifyReCaptchaModel } from '@/models/recaptcha.model';
import accountService from '@/services/account.service';

export default {
  verify(context: Vue, token: string): Promise<IGoogleResponse> {
    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "recaptcha/verify";

    return accountService.post<IVerifyReCaptchaModel, IGoogleResponse>(context, url, { Token: token })
      .then(response => {
        return response;
      })
      .catch(() => {
        return { Success: false } as IGoogleResponse;
      });
  },

  getToken(context: Vue, action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(context.$data.RCEnvironment.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY, { action: action })
          .then((token: string) => {
            return resolve(token);
          }, (error) => {
            return reject(error);
          })
      })
    });
  }
}
